module.exports = __webpack_public_path__ + "arrow_left.270f72df47e036d9cfa1.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/img/svg/arrow_left.svg
// module id = ../../../../../img/svg/arrow_left.svg
// module chunks = styles